import React from "react"
import {
  IconBooks,
  IconCalendarEvent,
  IconFolder,
  IconHash,
  IconScript,
  IconSearch,
  IconUser,
  type IconProps,
} from "@tabler/icons-react"
import type { SearchCategory } from "./search_hit"

// One icon per result category, so a row is scannable by shape before you read it.
const CATEGORY_ICONS: Record<SearchCategory, React.FC<IconProps>> = {
  Codex: IconScript,
  Profiles: IconUser,
  Collections: IconFolder,
  Events: IconCalendarEvent,
  Library: IconBooks,
  Topics: IconHash,
}

export const CategoryIcon: React.FC<{
  category: SearchCategory
  size?: number
  className?: string
}> = ({ category, size = 18, className }) => {
  const Icon = CATEGORY_ICONS[category] ?? IconSearch
  return <Icon size={size} className={className} aria-hidden="true" />
}
